import apiRequest from './index'

export default {
  path: '/v1/car',
  // get (id) {
  //   return apiRequest.get(`${this.path}?ts_id=${id}`)
  // },
  async get (id) {
    await window.callNativeHTTPX()
    return apiRequest.get(`${this.path}?ts_id=${id}`, {
      headers: {
        'HTTP-X-DAPP-REQUESTTIME': window.DAPP_REQUESTTIME,
        'HTTP-X-DAPP-USERID': window.DAPP_USERID,
        'HTTP-X-DAPP-AUTHCD': window.DAPP_AUTHCD
      }
    })
  },
  // post (car) {
  //   return apiRequest.post(this.path, { ...car })
  // }
  async post (car) {
    console.log('*** call API carpostAPI ***')
    console.log(car)
    await window.callNativeHTTPX()
    return apiRequest.post(this.path, { ...car }, {
      headers: {
        'HTTP-X-DAPP-REQUESTTIME': window.DAPP_REQUESTTIME,
        'HTTP-X-DAPP-USERID': window.DAPP_USERID,
        'HTTP-X-DAPP-AUTHCD': window.DAPP_AUTHCD
      }
    })
  },
  async delete (tsid) {
    await window.callNativeHTTPX()
    const id = {
      ts_id: tsid
    }
    return apiRequest.delete(this.path, {
      data: id,
      headers: {
        'HTTP-X-DAPP-REQUESTTIME': window.DAPP_REQUESTTIME,
        'HTTP-X-DAPP-USERID': window.DAPP_USERID,
        'HTTP-X-DAPP-AUTHCD': window.DAPP_AUTHCD
      }
    })
  }
}
